import axios from 'axios';

let cachedClientIp = '';
let hasInstalledInterceptor = false;

const normalizeIp = (value) => String(value || '').trim().replace(/^::ffff:/i, '');

const fetchPublicIp = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json', { method: 'GET' });
    if (!response.ok) return '';
    const data = await response.json();
    return normalizeIp(data?.ip);
  } catch {
    return '';
  }
};

export const setupClientIpHeader = async () => {
  if (!cachedClientIp) {
    cachedClientIp = normalizeIp(sessionStorage.getItem('clientPublicIp'));
  }

  if (!cachedClientIp) {
    cachedClientIp = await fetchPublicIp();
    if (cachedClientIp) {
      sessionStorage.setItem('clientPublicIp', cachedClientIp);
    }
  }

  if (hasInstalledInterceptor) {
    return;
  }

  axios.interceptors.request.use((config) => {
    if (!config.headers) config.headers = {};
    if (cachedClientIp) {
      config.headers['x-client-ip'] = cachedClientIp;
    }
    return config;
  });

  hasInstalledInterceptor = true;
};
